import type { DuelTeam } from "../types/leagueDuel";

// Avatar plein corps des duellistes (le même Character que dans le Profil).
// TODO League : remplacer par l'avatar composé (calques d'équipement) de chaque joueur.
export const DUELIST_CHARACTER_IMG = "https://pub-fe12241b7bb041a784ec4049e068ea80.r2.dev/Character.png";

// ─── Données mockées des équipes ──────────────────────────────────────────────
// Remplace plus tard par les vraies équipes / rosters (League). Ici : 5 joueurs
// chacun, avatars en emoji pour tester la lisibilité du terrain.

export function makeHomeTeam(captainName: string): DuelTeam {
  return {
    name: captainName,
    players: [
      { id: "h1", name: captainName, avatar: "🧑‍🦱", isCaptain: true },
      { id: "h2", name: "Léo", avatar: "🧑" },
      { id: "h3", name: "Sam", avatar: "🧔" },
      { id: "h4", name: "Kai", avatar: "👨‍🦰" },
      { id: "h5", name: "Théo", avatar: "🧑‍🦲" },
    ],
  };
}

export const MOCK_AWAY_TEAM: DuelTeam = {
  name: "Ghost FC",
  players: [
    { id: "a1", name: "Rival", avatar: "👤", isCaptain: true },
    { id: "a2", name: "Zeno", avatar: "🕵️" },
    { id: "a3", name: "Vex", avatar: "🧟" },
    { id: "a4", name: "Nox", avatar: "👽" },
    { id: "a5", name: "Rok", avatar: "🤖" },
  ],
};

// Construit une équipe de 5 autour d'un bot (le bot = capitaine).
export function makeBotTeam(botName: string, botAvatar: string): DuelTeam {
  const scrubs = ["Zeno", "Vex", "Nox", "Rok"];
  const avatars = ["🕵️", "🧟", "👽", "🤖"];
  return {
    name: botName,
    players: [
      { id: "a1", name: botName, avatar: botAvatar, isCaptain: true },
      ...scrubs.map((n, i) => ({ id: `a${i + 2}`, name: n, avatar: avatars[i] })),
    ],
  };
}
